import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  id: "mainDivNewsMail",
  class: "w-80 h-100"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */)
const _hoisted_3 = {
  id: "divNewsMailInput",
  class: "newsMail-div-input newsMail-align-center"
}
const _hoisted_4 = {
  id: "tblNewsMailInput",
  class: "newsMail-w-50 newsMail-mg-auto"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("td", { class: "newsMail-w-40 newsMail-align-right" }, [
  /*#__PURE__*/_createTextVNode("User ID"),
  /*#__PURE__*/_createElementVNode("span", { class: "newsMail-color-red" }, "*"),
  /*#__PURE__*/_createElementVNode("span", { class: "newsMail-mr-5" }, ":")
], -1 /* HOISTED */)
const _hoisted_6 = { class: "newsMail-w-20" }
const _hoisted_7 = { class: "newsMail-w-40" }
const _hoisted_8 = {
  colspan: "3",
  class: "newsMail-align-center"
}
const _hoisted_9 = { class: "newsMail-color-red" }
const _hoisted_10 = {
  id: "divNewsMailHeaderBody",
  class: "newsMail-div-HB-1"
}
const _hoisted_11 = /*#__PURE__*/_createStaticVNode("<div id=\"divNewsMailHeader\" class=\"newsMail-div-header1\"><table id=\"tblNewsMail\" class=\"newsMail-tbl-header1\"><thead><tr><th class=\"newsMail-w-8\">User ID</th><th class=\"newsMail-w-15\">User Name</th><th class=\"newsMail-w-13\">e-mail</th><th class=\"newsMail-w-27\">Company Name</th><th class=\"newsMail-w-20\">Coutry</th><th class=\"newsMail-w-10\">Title</th><th class=\"newsMail-w-7\"></th></tr></thead></table></div>", 1)
const _hoisted_12 = {
  id: "divNewsMailBody",
  class: "newsMail-div-body1"
}
const _hoisted_13 = {
  id: "tblNewsMail",
  class: "newsMail-tbl-body1"
}
const _hoisted_14 = { id: "tbodyNewsMailBody" }
const _hoisted_15 = { class: "newsMail-w-8 newsMail-align-center" }
const _hoisted_16 = { class: "newsMail-w-15" }
const _hoisted_17 = { class: "newsMail-w-13" }
const _hoisted_18 = { class: "newsMail-w-27" }
const _hoisted_19 = { class: "newsMail-w-20" }
const _hoisted_20 = { class: "newsMail-w-10" }
const _hoisted_21 = { class: "newsMail-w-7 newsMail-align-center" }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = { key: 0 }
const _hoisted_24 = {
  class: "modal fade",
  id: "deleteNewsMailModal",
  tabindex: "-1",
  "aria-labelledby": "deleteModalLabel",
  "aria-hidden": "true"
}
const _hoisted_25 = { class: "modal-dialog" }
const _hoisted_26 = {
  class: "modal-content",
  style: {"height":"40%"}
}
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("h5", {
    class: "modal-title",
    id: "deleteModalLabel"
  }, "Delete news"),
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn btn-close",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  })
], -1 /* HOISTED */)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", {
  class: "modal-body",
  style: {"flex":"0 0 auto"}
}, [
  /*#__PURE__*/_createElementVNode("div", null, "Are you sure to delete this mailing user?")
], -1 /* HOISTED */)
const _hoisted_29 = { class: "modal-footer" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-secondary",
  "data-bs-dismiss": "modal",
  id: "deleteCancel"
}, " Cancel ", -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode($setup["Loading"], { isLoading: $setup.isLoading }, null, 8 /* PROPS */, ["isLoading"]),
    _createVNode($setup["Alert"], {
      "alert-message": $setup.alertMessage,
      "alert-state": $setup.alertState
    }, null, 8 /* PROPS */, ["alert-message", "alert-state"]),
    _createVNode($setup["AdminNavigation"], { menuTile: $setup.menuTitle }, null, 8 /* PROPS */, ["menuTile"]),
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("table", _hoisted_4, [
        _createElementVNode("tbody", null, [
          _createElementVNode("tr", null, [
            _hoisted_5,
            _createElementVNode("td", _hoisted_6, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.userId) = $event))
              }, null, 512 /* NEED_PATCH */), [
                [_vModelText, $setup.userId]
              ])
            ]),
            _createElementVNode("td", _hoisted_7, [
              _createElementVNode("button", {
                class: "newsMail-btn newsMail-w-40",
                onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.onClickAddButton()))
              }, "Add")
            ])
          ]),
          _createElementVNode("tr", null, [
            _createElementVNode("td", _hoisted_8, [
              _createElementVNode("span", _hoisted_9, _toDisplayString($setup.errormessage), 1 /* TEXT */)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _hoisted_11,
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("table", _hoisted_13, [
          _createElementVNode("tbody", _hoisted_14, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.newsMailUserList[0], (info, index) => {
              return (_openBlock(), _createElementBlock("tr", { key: index }, [
                _createElementVNode("td", _hoisted_15, _toDisplayString(info.userId), 1 /* TEXT */),
                _createElementVNode("td", _hoisted_16, _toDisplayString(info.givenName) + " " + _toDisplayString(info.familyName), 1 /* TEXT */),
                _createElementVNode("td", _hoisted_17, _toDisplayString(info.email), 1 /* TEXT */),
                _createElementVNode("td", _hoisted_18, _toDisplayString(info.companyName), 1 /* TEXT */),
                _createElementVNode("td", _hoisted_19, _toDisplayString(info.country), 1 /* TEXT */),
                _createElementVNode("td", _hoisted_20, _toDisplayString(info.title), 1 /* TEXT */),
                _createElementVNode("td", _hoisted_21, [
                  _createElementVNode("button", {
                    class: "newsMail-btn",
                    onClick: ($event: any) => ($setup.setDeleteUser(info)),
                    "data-bs-toggle": "modal",
                    "data-bs-target": "#deleteNewsMailModal"
                  }, " Delete ", 8 /* PROPS */, _hoisted_22)
                ])
              ]))
            }), 128 /* KEYED_FRAGMENT */))
          ])
        ]),
        ($setup.newsMailUserList.length == 0 || $setup.newsMailUserList[0].length == 0)
          ? (_openBlock(), _createElementBlock("h5", _hoisted_23, "No Data"))
          : _createCommentVNode("v-if", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_24, [
      _createElementVNode("div", _hoisted_25, [
        _createElementVNode("div", _hoisted_26, [
          _hoisted_27,
          _hoisted_28,
          _createElementVNode("div", _hoisted_29, [
            _hoisted_30,
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary footer-btn",
              onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.onClickDeleteButton()))
            }, " Delete ")
          ])
        ])
      ])
    ])
  ]))
}